/* istanbul ignore next */
const ACTIONS = {
    GET_LISTING_METADATA_SUCCESS: 'GET_LISTING_METADATA_SUCCESS',
    GET_LISTING_METADATA: 'GET_LISTING_METADATA',
    UPDATE_PROPERTY_COUNT_INFO: 'UPDATE_PROPERTY_COUNT_INFO',
    SET_PROPERTY_COUNT_FIELD: 'SET_PROPERTY_COUNT_FIELD',
    VALIDATE_PROPERTY_COUNT_FIELD: 'VALIDATE_PROPERTY_COUNT_FIELD',
    LISTING_SERVICE_ERROR: 'LISTING_SERVICE_ERROR',
    PRE_POPULATE_P_COUNT_LOCAL_STATE: 'PRE_POPULATE_P_COUNT_LOCAL_STATE'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getListingMetadataSuccess(listingMetadata) {
        return {
            type: ACTIONS.GET_LISTING_METADATA_SUCCESS,
            payload: {
                listingMetadata
            }
        };
    },

    getListingMetadata() {
        return {
            type: ACTIONS.GET_LISTING_METADATA
        };
    },

    updatePropertyCountInfo(propertyCountInfo) {
        return {
            type: ACTIONS.UPDATE_PROPERTY_COUNT_INFO,
            payload: {
                propertyCountInfo
            }
        };
    },

    setPropertyCount(fieldValue) {
        return {
            type: ACTIONS.SET_PROPERTY_COUNT_FIELD,
            payload: {
                fieldValue
            }
        };
    },

    validatePropertyField(fieldValue) {
        return {
            type: ACTIONS.VALIDATE_PROPERTY_COUNT_FIELD,
            payload: {
                fieldValue
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.LISTING_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    prePopulateLocalState(publicUuid) {
        return {
            type: ACTIONS.PRE_POPULATE_P_COUNT_LOCAL_STATE,
            payload: {
                publicUuid
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
